// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
// <GetUserSnippet>
import { Client, GraphRequestOptions, PageCollection, PageIterator } from '@microsoft/microsoft-graph-client';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
// import { endOfWeek, startOfWeek } from 'date-fns';
// import { zonedTimeToUtc } from 'date-fns-tz';
import { User, Event, List } from 'microsoft-graph';
let graphClient: Client | undefined = undefined;
function ensureClient(authProvider: AuthCodeMSALBrowserAuthenticationProvider) {
  if (!graphClient) {
    graphClient = Client.initWithMiddleware({
      authProvider: authProvider
    });
  }
  return graphClient;
}
export async function getUser(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<User> {
  ensureClient(authProvider);
  // Return the /me API endpoint result as a User object
  const user: User = await graphClient!.api('/me')
    // Only retrieve the specific fields needed
    .select('displayName,mail,mailboxSettings,userPrincipalName')
    .get();
  return user;
}
// </GetUserSnippet>
export async function getList(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<User> {
  ensureClient(authProvider);
  // Return the /me API endpoint result as a User object
  const list: List = await graphClient!.api('/sites/91b42026-95e1-427b-9ba5-8cc33c44f538/lists/CLM365Formfieldname/items')
    // Only retrieve the specific fields needed
    //.select('displayName,mail,mailboxSettings,userPrincipalName')
    .get();
  return list;
}
export async function getListColumnName(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<User> {
  ensureClient(authProvider);
  // Return the /me API endpoint result as a User object
  const listColname: List = await graphClient!.api('/sites/91b42026-95e1-427b-9ba5-8cc33c44f538/lists/CLM365Formfieldname/columns')
    // Only retrieve the specific fields needed
    //.select('displayName,mail,mailboxSettings,userPrincipalName')
    .get()
//  let listcol=  listColname
  return listColname;
}
export async function getDocNamefromLibrary(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<User> {
  ensureClient(authProvider);
  // Return the /me API endpoint result as a User object
  const Docname: List = await graphClient!.api('/sites/91b42026-95e1-427b-9ba5-8cc33c44f538/drives/b!JiC0keGVe0KbpYzDPET1OPPOUIpssa5Psu3gQkYEFCd8izyogHTjTqZTQc6_7Uc4/root/children')
    // Only retrieve the specific fields needed
    //.select('displayName,mail,mailboxSettings,userPrincipalName')
    .get()
//  let listcol=  listColname
  return Docname;
}

export async function getDocContent(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<User> {
  ensureClient(authProvider);
 
  const DocContent: List = await graphClient!.api('/sites/91b42026-95e1-427b-9ba5-8cc33c44f538/drives/b!JiC0keGVe0KbpYzDPET1OPPOUIpssa5Psu3gQkYEFCd8izyogHTjTqZTQc6_7Uc4/items/01QV6GVAX75Q2MEWS2ORCJ2CXT5SPWJHOZ/content')
  
    .get()

  return DocContent;
}
// <GetUserWeekCalendarSnippet>
// export async function getUserWeekCalendar(authProvider: AuthCodeMSALBrowserAuthenticationProvider,
//   timeZone: string): Promise<Event[]> {
//   ensureClient(authProvider);

//   // Generate startDateTime and endDateTime query params
//   // to display a 7-day window
//   const now = new Date();
//   const startDateTime = zonedTimeToUtc(startOfWeek(now), timeZone).toISOString();
//   const endDateTime = zonedTimeToUtc(endOfWeek(now), timeZone).toISOString();

//   // GET /me/calendarview?startDateTime=''&endDateTime=''
//   // &$select=subject,organizer,start,end
//   // &$orderby=start/dateTime
//   // &$top=50
//   var response: PageCollection = await graphClient!
//     .api('/me/calendarview')
//     .header('Prefer', `outlook.timezone="${timeZone}"`)
//     .query({ startDateTime: startDateTime, endDateTime: endDateTime })
//     .select('subject,organizer,start,end')
//     .orderby('start/dateTime')
//     .top(25)
//     .get();

//   if (response["@odata.nextLink"]) {
//     // Presence of the nextLink property indicates more results are available
//     // Use a page iterator to get all results
//     var events: Event[] = [];

//     // Must include the time zone header in page
//     // requests too
//     var options: GraphRequestOptions = {
//       headers: { 'Prefer': `outlook.timezone="${timeZone}"` }
//     };

//     var pageIterator = new PageIterator(graphClient!, response, (event) => {
//       events.push(event);
//       return true;
//     }, options);

//     await pageIterator.iterate();

//     return events;
//   } else {

//     return response.value;
//   }
// }
// </GetUserWeekCalendarSnippet>

// <CreateEventSnippet>
// export async function createEvent(authProvider: AuthCodeMSALBrowserAuthenticationProvider,
//   newEvent: Event): Promise<Event> {
//   ensureClient(authProvider);

//   // POST /me/events
//   // JSON representation of the new event is sent in the
//   // request body
//   return await graphClient!
//     .api('/me/events')
//     .post(newEvent);
// }
// </CreateEventSnippet>
